import React, { useState, useEffect } from "react";
import {
  CNavbar,
  CNavbarBrand,
  CContainer,
  CNavbarNav,
  CNavItem,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
} from "@coreui/react-pro";

import { useTranslation } from "react-i18next";
import logo from "src/assets/icon/logo.png";

function NavbarIntermodal() {
  const [scrolled, setScrolled] = useState(false);
  const { t, i18n } = useTranslation();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };
  const currentLang = i18n.language?.split("-")[0] || "pt";
  const langLabels = { pt: "PT", en: "EN", es: "ES" };

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 0;
      setScrolled(isScrolled);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <CNavbar
      className={`navLandingPageIntermodal py-4 ${scrolled ? "scrolled" : ""}`}
      translate="no"
    >
      <div className="nav-container">
        <CContainer fluid>
          <a href="www.ghlogistica.com.br" className="back">
            {t("lp4_nav_back")} <div className="underline"></div>
          </a>
          <CNavbarBrand className="navLogo">
            <a href="/">
              <img src={logo} alt="logo" width={200} />
            </a>
          </CNavbarBrand> 
          <CNavbarNav className="flex-row align-items-center gap-0">
            <CNavItem className="px-1 registerLink">
              <a href="/intermodal2026/pitstop">
                {t("lp_driver_nav_register")}
              </a>
            </CNavItem>
            <CDropdown variant="btn-group" className="langLink">
              <CDropdownToggle className="langToggle">
                {langLabels[currentLang] || "PT"}
              </CDropdownToggle>
              <CDropdownMenu>
                <CDropdownItem
                  onClick={() => changeLanguage("pt")}
                  className={currentLang === "pt" ? "lang-active" : ""}
                >
                  Português
                </CDropdownItem>
                <CDropdownItem
                  onClick={() => changeLanguage("en")}
                  className={currentLang === "en" ? "lang-active" : ""}
                >
                  English
                </CDropdownItem>
                <CDropdownItem
                  onClick={() => changeLanguage("es")}
                  className={currentLang === "es" ? "lang-active" : ""}
                >
                  Español
                </CDropdownItem>
              </CDropdownMenu>
            </CDropdown>
          </CNavbarNav>
        </CContainer>
      </div>
    </CNavbar>
  );
}

export default NavbarIntermodal;